import React, { useState } from "react";
import axios from "axios";
import "./../stylesloin.scss";

export default function ElementForgotPassword({
  setActiveView,   // optional: e.g., setActiveView('reset')
  setEmailGlobal,  // optional: if you keep email in parent
  t,        
   eyeClosedIcon,
     eyeOpenIcon     // optional i18n function
}) {
  const tr = (k, fb) => (typeof t === "function" ? t(k) : fb);

  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  const isEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);

  const sendOTP = async (e) => {
    e.preventDefault();
    setMessage("");

    const normalized = email.trim().toLowerCase();
    if (!isEmail(normalized)) {
      setMessage(tr("invalidEmailError","Enter a valid email."));
      return;
    }

    try {
      setSending(true);
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE}/send-otp`,
        { email: normalized }
        // , { withCredentials: true }
      );
      setMessage(res?.data?.message || tr("otpSent", "OTP sent to your email."));
      setEmailGlobal?.(normalized);
      setActiveView?.("reset");
    } catch (err) {
      setMessage(tr("errorSendingOTP", "Error sending OTP"));
      console.error(err);
    } finally {
      setSending(false);
    }
  };

  const invalid = email.length > 0 && !isEmail(email);
  const canSend = !sending && isEmail(email);

  return (
    <main className="auth">
      <span aria-hidden className="page-bottom-glow" />
      <section className="container auth__container">
        <header className="auth__header">
          <h1>{t("forgotPasswordTitle")}</h1>
          <p>{tr("forgotPasswordSubtitle", "We’ll email you a one-time code.")}</p>
        </header>

        <form className="auth__card" onSubmit={sendOTP} noValidate>
          <div className="field">
            <label htmlFor="fp-email">{tr("emailLabel", "Email")}</label>
            <input
              id="fp-email"
              type="email"
              placeholder={tr("enterEmailPlaceholder", "Enter your email")}
              autoComplete="email"
              required
              aria-invalid={invalid}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <button type="submit" className="btn-primary w-full" disabled={!canSend}>
            {sending ? tr("sending","Sending…") : tr("sendOTP", "Send OTP")}
          </button>

          {message ? (
            <p className="auth__message" aria-live="polite">{message}</p>
          ) : null}
        </form>

        <p className="auth__switch">
          {tr("remembered", "Remembered your password?")}{" "}
          <a
            href="/login"
            onClick={(e) => (setActiveView ? (e.preventDefault(), setActiveView("login")) : null)}
          >
            {tr("backToLogin", "Back to login")}
          </a>
        </p>
      </section>
    </main>
  );
}
